import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';

type FilterMultiSelectProps = {
  htmlId: string;
  label: string;
  options: { id: string; label: string }[];
  value: string[];
  onChange: (event: string[]) => void;
};

export default function FilterMultiSelect(props: FilterMultiSelectProps) {
  const renderLabelFromOption = (ids: string[]) => {
    if (ids.length > 1) return `${ids.length} selected`;
    return props.options
      .filter(option => ids.includes(option.id))
      .map(option => option.label)
      .join(', ');
  };

  return (
    <FormControl fullWidth>
      <InputLabel>{props.label}</InputLabel>
      <Select
        multiple
        renderValue={renderLabelFromOption}
        labelId={`${props.htmlId}-label`}
        id={props.htmlId}
        value={props.value}
        onChange={e => props.onChange(e.target.value as string[])}
      >
        {props.options.map(option => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox checked={props.value.indexOf(String(option.id)) > -1} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
